import Button from '@deprecated-ui/common/Button';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import { useNotificationData } from 'lib/entities/notification/useNotificationData';

function NotificationFooter() {
  const tab = useNotificationData((store) => store.tab);
  const lastId = useNotificationData((store) => store.contents[tab].lastId);
  const total = useNotificationData((store) => store.contents[tab].list.length);
  const isLoading = useNotificationData((store) => store.isLoading);
  const isLoadingPrevious = useNotificationData(
    (store) => store.isLoadingPrevious,
  );
  const getPrevNotification = useNotificationData(
    (store) => store.getPrevNotification,
  );

  const handlePrevClick = () => {
    getPrevNotification(tab, lastId);
  };

  if (isLoading && total === 0) {
    return null;
  }

  return (
    <Button
      className="load-button"
      block
      height="36px"
      onClick={handlePrevClick}
      loading={isLoadingPrevious}
    >
      {!isLoadingPrevious && (
        <Text color={color.primary} align="center">
          Load Previous
        </Text>
      )}
    </Button>
  );
}

export default NotificationFooter;
